module.exports = __webpack_public_path__ + "static/media/goaplha.646ded3b.jpg";